import { render, staticRenderFns } from "./certificate-select-modal.vue?vue&type=template&id=0b10b050&"
import script from "./certificate-select-modal.vue?vue&type=script&lang=js&"
export * from "./certificate-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./certificate-select-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports